<script setup>
import {GenderLabel, IsChildLabel} from "@/choices";
import {convertPriorityToColor, PriorityLabel} from "@/components/hpo/choices";
import WizardSummary from "@/components/wizard/WizardSummary.vue";
import WizardSummaryField from "@/components/wizard/WizardSummaryField.vue";

const props = defineProps({
    isEditing: {
        type: Boolean,
        default: false,
    },
    personId: {
        type: [Number, String],
    },
    formData: {
        type: Object,
        required: true,
    },
    isSubmitting: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: pgettext('title', 'Summary'),
    },
    buttonText: {
        type: String,
        default: pgettext('action', 'Save'),
    },
});
const emit = defineEmits(['pushStep', 'submit']);

function goToStep(stepName) {
    emit('pushStep', stepName);
}

function submit() {
    emit('submit', props.formData);
}
</script>

<template>
    <main>
        <h1>{{ title }}</h1>

        <v-alert v-if="personId" type="info" variant="tonal" class="mb-8">
            <strong v-if="isEditing">
                {{ interpolate(gettext('You are editing patient %(tic)s.'), {tic: `${formData.ticPrefix}${formData.ticNumber}`}) }}
            </strong>
            <strong v-else>
                {{ interpolate(gettext('Patient %(tic)s was already added.'), {tic: `${formData.ticPrefix}${formData.ticNumber}`}) }}
            </strong>
        </v-alert>

        <div class="d-flex justify-center">
            <WizardSummary>
                <WizardSummaryField :title="pgettext('label', 'TIC')" @edit="goToStep('tic')">
                    {{ formData.ticPrefix }}{{ formData.ticNumber }}
                </WizardSummaryField>
                <WizardSummaryField :title="pgettext('label', 'Gender')" @edit="goToStep('gender')">
                    {{ GenderLabel[formData.gender] }}
                </WizardSummaryField>
                <WizardSummaryField :title="pgettext('label', 'Age')" @edit="goToStep('isChild')">
                    {{ IsChildLabel[formData.isChild] }}
                </WizardSummaryField>
                <WizardSummaryField :title="pgettext('label', 'Treatment Priority')" @edit="goToStep('treatmentPriority')">
                    <v-chip v-if="formData.treatmentPriority" density="compact" variant="flat" size="large" :ripple="false" :color="convertPriorityToColor(formData.treatmentPriority).toLowerCase()" rounded class="py-0 px-5">
                        <strong>{{ PriorityLabel[formData.treatmentPriority] }}</strong>
                    </v-chip>
                </WizardSummaryField>
            </WizardSummary>
        </div>

        <div class="text-center mt-8">
            <v-btn @click="submit()" color="green" size="large" :loading="isSubmitting">
                {{ buttonText }}
            </v-btn>
        </div>
    </main>
</template>
